import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from 'views/MathClub/components/Archive2022';
import Sidebar2025 from '../MathClub2023/components/Sidebar2025';


const MathCCAClass32025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url_2025: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA3/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA3/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA3/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/MathClub/MathCCA3/4.webp`;




    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        }

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                  MATH CCA
                                </Typography>
                                 <br></br>
                                <Typography variant='h7' align='justify' >
                                Class 3: Protect and Preserve the Aqua World
                                <br></br>
                                Class 4: Care and Coexistence with Domestic Animals
                                <br></br>
                                Class 5: Rediscovering the Past: Life of Dinosaurs 
                                </Typography>
                                <br></br>
                               
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Classes: 3-5  Date: 23,24 & 25 July 2025
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                   The final round of the Math CCA for Classes 3, 4 and 5 was conducted on 23, 24 and 25 July 2025. Students creatively integrated mathematical concepts into storytelling, showcasing their understanding through engaging skits and visual presentations.
                                    <br></br>
                                    Class 3 explored the theme “Protect and Preserve the Aqua World.” Students used basic counting, patterns and shapes, which were effectively illustrated on chart paper, bringing simple stories to life with Math. They demonstrated how Mathematics can be meaningfully applied to environmental themes through visual storytelling.
                                    <br></br>
                                    Class 4 presented the theme “Care and Coexistence with Domestic Animals.” Their chart work and skits highlighted daily scenarios involving animals, incorporating addition, fractions and Geometry to solve relatable problems. Through this, they showcased the ability to use Math in daily decision-making while building awareness of compassion and responsibility.
                                    <br></br>
                                    Class 5 worked on “Rediscovering the Past: Life of Dinosaurs.” Through model-based displays and roleplay, students integrated concepts such as large numbers, measurement and Geometry, connecting Math with historical imagination. Their work reflected strong skills in spatial understanding, estimation and the creative application of mathematical knowledge.
                                    <br></br><br></br>
                                    Students found the activity enjoyable and meaningful, as it helped them see the connection between Math, creativity and the world around them.
                                   
                                </Typography>
                            </Box>
                            <Typography
                                      variant={'h6'}
                                      color={'primary'}
                                      align={'center'}
                                      fontWeight={'normal'}
                                    ><br/>
                            "When stories meet numbers, learning comes alive."
                            
                            <br/>
                                    </Typography>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box marginBottom={4}>
                            <Sidebar2025 />
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default MathCCAClass32025;